import React, { useEffect, useMemo, useState } from "react";
import Logo from "../../assets/medcase-logo.png";
import SOS from "../../assets/sos.jpeg";
import Consult from "../../assets/consult.jpeg";
import Video from "../../assets/VideoCamera.png";
import Syrup from "../../assets/syrup.jpeg";
import { Marquee } from "@/components/ui/marquee";
import { ImageIcon } from "lucide-react";

interface PreviewProps {
  layout: string | null;
  formData: {
    image: File | string | null;
    title: string;
    description: string;
  };
}

const actions = [
  SOS,
  Consult,
  Video,
  Syrup
]


export function AdPreview({ layout, formData }: PreviewProps) {
  if (!layout) return null;

  const imageURL =
    formData.image instanceof File
      ? URL.createObjectURL(formData.image)
      : typeof formData.image === "string"
        ? formData.image
        : null;

  return (
    <div className="border rounded-lg bg-gray-50 flex flex-col gap-4 justify-center items-center">
      {layout === "layout2" && (
        <div className="p-4 w-full">
          <div className="grid grid-rows-[auto_100px] grid-cols-[210px_auto] w-[840px] h-[410px] rounded-lg border overflow-hidden">
            {/* Top-left green */}
            <div className="bg-gray-100 relative flex items-center justify-center">
              {imageURL ? (
                <img
                  src={imageURL}
                  alt="ad"
                  className="w-full h-full object-cover"
                />
              ) : <div className="flex flex-col items-center justify-center gap-2">
                <ImageIcon className="text-gray-300" />
                <span className="text-gray-500 text-sm">210px x 308px</span>
              </div>}
            </div>
            {/* Top-right gray */}
            <div className="bg-gray-300"></div>
            {/* Bottom-left gray */}
            <div className="bg-green-600 flex items-center justify-center p-4">
              <img src={Logo} alt="medcase" className="object-cover rounded-sm flex-shrink-0" />
            </div>
            {/* Bottom-right gray */}
            <div className="bg-white flex items-start justify-center p-2 gap-6">
              {actions.map((action, index) => (
                <img src={action} alt="medcase" className="object-cover rounded-sm flex-shrink-0 h-full" key={index} />
              ))}
            </div>
          </div>
        </div>
      )}

      {layout === "layout1" && (
        <div className="p-4 w-full">
          <div className="grid grid-rows-[auto_100px] grid-cols-[100px_auto] w-[840px] h-[410px] border rounded-lg overflow-hidden">
            {/* Top-left gray */}
            <div className="bg-white flex flex-col items-start justify-center px-6 gap-3">
              {actions.map((action, index) => (
                <img src={action} alt="medcase" className="object-cover rounded-sm flex-shrink-0 w-full" key={index} />
              ))}
            </div>

            {/* Top-right gray */}
            <div className="bg-gray-300"></div>
            {/* Bottom-left gray */}
            <div className="bg-green-600 flex items-center justify-center p-1">
              <img src={Logo} alt="medcase" className="object-cover rounded-sm flex-shrink-0" />
            </div>
            {/* Bottom-right green */}
            <div className="col-span-1 row-span-1 relative flex font-bold p-2">
              {/* Image on the left */}
              {imageURL ? (
                <img
                  src={imageURL}
                  alt="ad"
                  className="w-60 object-cover rounded-sm flex-shrink-0"
                />
              ) : <div className="bg-gray-100 h-full rounded-smn flex flex-col justify-center items-center gap-2">
                <ImageIcon className="text-gray-300 w-60" />
                <span className="text-gray-500 text-sm font-normal">240px x 84px</span>
              </div>}

              {/* Title and scrolling description on the right */}
              <div className="flex flex-col justify-center ml-2 flex-1 overflow-hidden">
                {/* Title */}
                <div className="text-lg font-semibold">{formData.title || ""}</div>

                {/* Scrolling description */}
                <Marquee text={formData.description || ""} />

              </div>
            </div>
          </div>

        </div>
      )}

    </div>
  );
}

